export default {
    styleOverrides: {
      elevation1: {
        boxShadow: "0 2px 4px rgba(209, 213, 219, 0.5) !important",  
        border: "none",
      },
      elevation2: {
        boxShadow: "0 2px 4px rgba(209, 213, 219, 0.5) !important", 
        borderBottom: "0px solid #d1d5db",
      },
      elevation3: {
        boxShadow: "0 2px 4px rgba(209, 213, 219, 0.5) !important", 
        border: "1px solid rgba(209, 213, 219, 0.30)",
        borderRadius: '16px'
      },
    },
  };
  